import { render } from "./regalos.vue?vue&type=template&id=4b80c5be&scoped=true"
import script from "./regalos.vue?vue&type=script&lang=js"
export * from "./regalos.vue?vue&type=script&lang=js"

import "./regalos.vue?vue&type=style&index=0&id=4b80c5be&scoped=true&lang=css"
import "./regalos.vue?vue&type=style&index=1&id=4b80c5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b80c5be"]])

export default __exports__